<template>
  <el-card>
    <loading :loading_ok="loading_ok"></loading>
    <span class="title">练习/考试</span>

    <el-table :data="tableData" border stripe>
      <el-table-column type="index" label="#"></el-table-column>
      <el-table-column prop="Name" label="名称"></el-table-column>
      <el-table-column prop="introduce" label="科目" min-width="50">
        <template slot-scope="scope">
          <el-tag size="mini">{{ scope.row.Subject }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="单选题数/分数">
        <template slot-scope="scope">
          {{ scope.row.QuestionCount.SingleChoiceQuestion }} /
          {{ scope.row.QuestionScore.SingleChoiceQuestion }}
        </template>
      </el-table-column>
      <el-table-column label="多选题数/分数">
        <template slot-scope="scope">
          {{ scope.row.QuestionCount.MultiChoiceQuestion }} /
          {{ scope.row.QuestionScore.MultiChoiceQuestion }}
        </template>
      </el-table-column>
      <el-table-column label="判断题数/分数">
        <template slot-scope="scope">
          {{ scope.row.QuestionCount.TrueFalseQuestion }} /
          {{ scope.row.QuestionScore.TrueFalseQuestion }}
        </template>
      </el-table-column>
      <el-table-column label="问答题数/分数">
        <template slot-scope="scope">
          {{ scope.row.QuestionCount.AnswerQuestion }} /
          {{ scope.row.QuestionScore.AnswerQuestion }}
        </template>
      </el-table-column>
      <el-table-column label="Scratch题数/分数" min-width="90">
        <template slot-scope="scope">
          {{ scope.row.QuestionCount.ScratchQuestion }} /
          {{ scope.row.QuestionScore.ScratchQuestion }}
        </template>
      </el-table-column>
      <el-table-column prop="Score" label="总分" min-width="40">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            icon="el-icon-s-promotion"
            size="mini"
            @click="question_management(scope.row)"
          >
            进入试题
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 试题管理弹框 -->
    <el-dialog
      title="试题管理"
      fullscreen
      :visible.sync="dialog_question_management"
      :close-on-click-modal="false"
    >
      <!-- 题目区域 -->
      <div class="dialog_questions_style">
        <div class="left">{{ question_active.Name }}</div>
        <div class="right">
          <el-button type="primary" size="mini" @click="next_topic">
            下一题
          </el-button>
          <el-button size="mini" @click="submit_question_bank">
            提交题库
          </el-button>
        </div>
      </div>

      <div class="dialog_questions_style_bottom">
        <el-alert
          v-if="subject_active.Submitted"
          title="本题已做"
          show-icon
          type="success"
          style="margin-bottom:12px;"
        ></el-alert>

        <!-- 题目 question_active-->
        <p class="content" v-html="subject_active.Describe"></p>

        <!-- 单选题 -->
        <div
          class="radio_style"
          v-if="subject_active.Type == 'SingleChoiceQuestion'"
        >
          <el-radio-group
            v-model="form_questions.radio_answer"
            @change="radio_change"
          >
            <div class="radio_style_bottom">
              <el-radio :label="0">
                A、<span
                  style="display: inline-block;"
                  v-html="
                    subject_active.ExtraField.SingleChoiceField.Choices[0]
                  "
                ></span
              ></el-radio>
            </div>
            <div class="radio_style_bottom">
              <el-radio :label="1">
                B、<span
                  style="display: inline-block;"
                  v-html="
                    subject_active.ExtraField.SingleChoiceField.Choices[1]
                  "
                ></span
              ></el-radio>
            </div>
            <div class="radio_style_bottom">
              <el-radio :label="2">
                C、<span
                  style="display: inline-block;"
                  v-html="
                    subject_active.ExtraField.SingleChoiceField.Choices[2]
                  "
                ></span
              ></el-radio>
            </div>
            <div class="radio_style_bottom">
              <el-radio :label="3">
                D、<span
                  style="display: inline-block;"
                  v-html="
                    subject_active.ExtraField.SingleChoiceField.Choices[3]
                  "
                ></span
              ></el-radio>
            </div>
          </el-radio-group>
        </div>

        <!-- 多选题 -->
        <div
          class="radio_style"
          v-if="subject_active.Type == 'MultiChoiceQuestion'"
        >
          <el-checkbox-group
            @change="checkbox_change"
            v-model="form_questions.checkList"
          >
            <el-checkbox :label="0" style="display: block;">
              A、<span
                style="display: inline-block;"
                v-html="subject_active.ExtraField.MultiChoiceField.Choices[0]"
              >
              </span
            ></el-checkbox>
            <el-checkbox :label="1" style="display: block;margin-top:10px;">
              B、<span
                style="display: inline-block;"
                v-html="subject_active.ExtraField.MultiChoiceField.Choices[1]"
              >
              </span
            ></el-checkbox>
            <el-checkbox :label="2" style="display: block;margin-top:10px;">
              C、<span
                style="display: inline-block;"
                v-html="subject_active.ExtraField.MultiChoiceField.Choices[2]"
              >
              </span
            ></el-checkbox>
            <el-checkbox :label="3" style="display: block;margin-top:10px;">
              D、<span
                style="display: inline-block;"
                v-html="subject_active.ExtraField.MultiChoiceField.Choices[3]"
              >
              </span
            ></el-checkbox>
          </el-checkbox-group>
        </div>

        <!-- 判断题 -->
        <div
          class="radio_style"
          v-if="subject_active.Type == 'TrueFalseQuestion'"
        >
          <el-radio-group
            @change="radio_change"
            v-model="form_questions.radio_judge"
          >
            <el-radio :label="true">
              A. 正确
            </el-radio>
            <el-radio :label="false">
              B. 错误
            </el-radio>
          </el-radio-group>
        </div>

        <!-- 问答题 -->
        <div class="radio_style" v-if="subject_active.Type == 'AnswerQuestion'">
          <quillA v-if="blanks_type" v-model="form_questions.blanks"></quillA>
          <el-button
            type="primary"
            size="mini"
            @click="submit_test_paper"
            style="margin-top:20px;"
          >
            提交试题
          </el-button>
        </div>

        <!-- Scratch题 -->
        <div
          class="radio_style"
          v-if="subject_active.Type == 'ScratchQuestion'"
        >
          <ul>
            <li>
              <el-button @click="to_scratch" type="primary" size="mini"
                >进入Scratch</el-button
              >
              <img src="../assets/stylus/image/default.jpg" />
            </li>
          </ul>
        </div>
      </div>

      <!-- 答题卡区域 -->
      <div class="answer_sheet">
        <p class="title">答题卡</p>

        <div class="choice_questions">
          <p class="title">一、单项选择题</p>
          <div class="radio_display">
            <div
              v-for="(item, index) in question_tableData.SingleChoiceQuestion"
              :key="index"
              :style="
                item.Submitted ? 'border:1px solid #67C23A;color:#67C23A' : ''
              "
              :class="item.Id == subject_active.Id ? 'radio_active' : 'radio'"
              @click="radio_click(item)"
            >
              {{ index + 1 }}
            </div>
          </div>
        </div>

        <div class="choice_questions">
          <p class="title">二、多项选择题</p>
          <div class="radio_display">
            <div
              v-for="(item, index) in question_tableData.MultiChoiceQuestion"
              :key="index"
              :style="
                item.Submitted ? 'border:1px solid #67C23A;color:#67C23A' : ''
              "
              :class="item.Id == subject_active.Id ? 'radio_active' : 'radio'"
              @click="radio_click(item)"
            >
              {{ index + 1 }}
            </div>
          </div>
        </div>

        <div class="choice_questions">
          <p class="title">三、判断题</p>
          <div class="radio_display">
            <div
              v-for="(item, index) in question_tableData.TrueFalseQuestion"
              :key="index"
              :style="
                item.Submitted ? 'border:1px solid #67C23A;color:#67C23A' : ''
              "
              :class="item.Id == subject_active.Id ? 'radio_active' : 'radio'"
              @click="radio_click(item)"
            >
              {{ index + 1 }}
            </div>
          </div>
        </div>

        <div class="choice_questions">
          <p class="title">四、问答题</p>
          <div class="radio_display">
            <div
              v-for="(item, index) in question_tableData.AnswerQuestion"
              :key="index"
              :style="
                item.Submitted ? 'border:1px solid #67C23A;color:#67C23A' : ''
              "
              :class="item.Id == subject_active.Id ? 'radio_active' : 'radio'"
              @click="radio_click(item)"
            >
              {{ index + 1 }}
            </div>
          </div>
        </div>

        <div class="choice_questions">
          <p class="title">五、Scratch题</p>
          <div class="radio_display">
            <div
              v-for="(item, index) in question_tableData.ScratchQuestion"
              :key="index"
              :style="
                item.Submitted ? 'border:1px solid #67C23A;color:#67C23A' : ''
              "
              :class="item.Id == subject_active.Id ? 'radio_active' : 'radio'"
              @click="radio_click(item)"
            >
              {{ index + 1 }}
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 做题弹框 -->
    <el-dialog
      title="题目"
      :visible.sync="dialog_add_test_questions"
      :close-on-click-modal="false"
      @close="dialog_close"
      width="80%"
      v-if="form_questions_type"
    >
      <!-- 科目类型 -->
      <div class="questions">
        <p><span>*</span>科目类型</p>
        <div>{{ form_questions.subject }}</div>
      </div>

      <!-- 试题类型 -->
      <div class="questions">
        <p><span>*</span>试题类型</p>
        <el-tag>
          {{ form_questions.radio_type }}
        </el-tag>
      </div>

      <div class="questions">
        <p><span>*</span>分数</p>
        <el-input
          disabled
          style="width:300px;"
          placeholder="请输入分数"
          type="number"
          v-model="form_questions.score"
        ></el-input>
      </div>

      <!-- 试题描述 -->
      <div
        class="questions"
        v-if="form_questions.radio_type == '单选题' || '多选题'"
      >
        <p><span>*</span>试题描述</p>

        <div v-html="form_questions.describe"></div>
      </div>

      <!-- 试题题目 -->
      <div class="questions">
        <p><span>*</span>试题题目</p>

        <p v-html="form_questions.name"></p>
      </div>

      <!-- 试题选项 A -->
      <div
        class="questions"
        v-if="['单选题', '多选题'].includes(form_questions.radio_type)"
      >
        <p>A</p>
        <div v-html="form_questions.choices[0]"></div>
      </div>

      <!-- 试题选项 B -->
      <div
        class="questions"
        v-if="['单选题', '多选题'].includes(form_questions.radio_type)"
      >
        <p>B</p>
        <div v-html="form_questions.choices[1]"></div>
      </div>

      <!-- 试题选项 C -->
      <div
        class="questions"
        v-if="['单选题', '多选题'].includes(form_questions.radio_type)"
      >
        <p>C</p>
        <div v-html="form_questions.choices[2]"></div>
      </div>

      <!-- 试题选项 D -->
      <div
        class="questions"
        v-if="['单选题', '多选题'].includes(form_questions.radio_type)"
      >
        <p>D</p>
        <div v-html="form_questions.choices[3]"></div>
      </div>

      <!-- 问答题 -->
      <div
        class="questions"
        v-if="form_questions.radio_type == '问答题' ? true : false"
      >
        <p><span>*</span>问答题</p>

        <quillA v-if="blanks_type" v-model="form_questions.blanks"></quillA>
      </div>

      <div
        class="questions"
        style="margin-top: 30px;"
        v-if="form_questions.radio_type == '问答题' ? false : true"
      >
        <p><span>*</span>试题答案</p>
        <div v-if="form_questions.radio_type == '单选题'">
          <el-radio v-model="form_questions.radio_answer" :label="0">
            A
          </el-radio>
          <el-radio v-model="form_questions.radio_answer" :label="1">
            B
          </el-radio>
          <el-radio v-model="form_questions.radio_answer" :label="2">
            C
          </el-radio>
          <el-radio v-model="form_questions.radio_answer" :label="3">
            D
          </el-radio>
        </div>
        <div v-if="form_questions.radio_type == '多选题'">
          <el-checkbox-group v-model="form_questions.checkList">
            <el-checkbox :label="0">A</el-checkbox>
            <el-checkbox :label="1">B</el-checkbox>
            <el-checkbox :label="2">C</el-checkbox>
            <el-checkbox :label="3">D</el-checkbox>
          </el-checkbox-group>
        </div>
        <div v-if="form_questions.radio_type == '判断题'">
          <el-radio v-model="form_questions.radio_judge" :label="true">
            A. 正确
          </el-radio>
          <el-radio v-model="form_questions.radio_judge" :label="false">
            B. 错误
          </el-radio>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog_add_test_questions = false" size="mini">
          取消
        </el-button>
        <el-button type="primary" @click="determine_test_questions" size="mini">
          确定
        </el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import { mapGetters } from "vuex";
import loading from "@/components/loading.vue";
import {
  put_answer_api,
  put_submission_api,
  get_answer_api,
  get_student_question_sheet_api,
  get_user_answer_api,
  get_score_api,
} from "@/api/question.js";
import quillA from "./components/quill_editor_A.vue";

export default {
  computed: {
    ...mapGetters(["userInfo", "current"]),
  },
  components: {
    quillA,
    loading,
  },
  data() {
    return {
      dialog_question: false,
      dialog_question_management: false,
      dialog_add_test_questions: false,
      tableData: [],
      question_tableData: [],
      form: { name: "", subject: "" },
      form_questions: {
        name: "", //试题题目
        describe: "", //试题解析
        blanks: "", //简答题
        choices: [],
        radio_type: "单选题", //题目类型
        radio_answer: "", //单选题答案
        radio_judge: "",
        checkList: [],
        subject: "",
        Material: "", //Scratch模版ID
      },
      options: [
        {
          value: "C++",
          label: "C++",
        },
        {
          value: "Python",
          label: "Python",
        },
        {
          value: "Scratch",
          label: "Scratch",
        },
      ],
      form_questions_type: false,
      assign_classes: false,
      class_form: { classId: "", sheetId: "" },
      activeName: " ",
      questionIndex: "",
      blanks_type: false,
      question_active: [],
      subject_active: {
        ExtraField: {
          SingleChoiceField: { Choices: [] },
        },
      },
      Submitted: "",
      SheetType: "",
      loading_ok: "",
    };
  },

  created() {
    this.get_question_sheet();
  },

  methods: {
    changeData(curVal, oldVal) {
      conosle.log(curVal, oldVal);
    },

    //获取题库
    get_question_sheet() {
      get_student_question_sheet_api().then((res) => {
        console.log(res.data);
        // res.data.forEach((r, i) => {
        //   get_score_api(this.userInfo.Name, r.Id).then((v) => {
        //     r.Score = v.data.Score;
        //     r.Submitted = v.data.Submitted;
        //     if (res.data.length == i + 1) {
        //       this.tableData = res.data;
        //       this.loading_ok = false;
        //     }
        //   });
        // });
      });
    },

    //做题按钮
    edit_form_question(item, index) {
      get_user_answer_api(item.Id, this.userInfo.Name).then((res) => {
        let value = res.data.Answer;
        if (item.Type == "SingleChoiceQuestion" && item.Submitted) {
          this.form_questions.radio_answer = value.SingleChoice;
        } else if (item.Type == "MultiChoiceQuestion" && item.Submitted) {
          this.form_questions.checkList = value.MultiChoice;
        } else if (item.Type == "TrueFalseQuestion" && item.Submitted) {
          this.form_questions.radio_judge = value.TrueFalse;
        } else if (item.Type == "AnswerQuestion" && item.Submitted) {
          this.form_questions.blanks = value.Answer;
          this.blanks_type = true;
        }
      });
      this.form_questions.radio_judge = "";
      this.form_questions.checkList = [];
      this.form_questions.radio_answer = "";
      this.questionIndex = index;
      this.form_questions_type = true;
      this.form_questions.name = "";
      this.form_questions.id = item.Id;
      this.form_questions.score = item.Score;
      if (item.Type == "SingleChoiceQuestion") {
        this.form_questions.describe = item.Describe;
        this.form_questions.name = item.Name;
        this.form_questions.subject = item.Subject;
        this.form_questions.radio_type = "单选题";
        this.form_questions.choices = item.ExtraField.SingleChoiceField.Choices;
      } else if (item.Type == "MultiChoiceQuestion") {
        this.form_questions.describe = item.Describe;
        this.form_questions.name = item.Name;
        this.form_questions.radio_type = "多选题";
        this.form_questions.subject = item.Subject;
        this.form_questions.choices = item.ExtraField.MultiChoiceField.Choices;
      } else if (item.Type == "TrueFalseQuestion") {
        this.form_questions.describe = item.Describe;
        this.form_questions.name = item.Name;
        this.form_questions.radio_type = "判断题";
        this.form_questions.subject = item.Subject;
      } else if (item.Type == "AnswerQuestion") {
        this.form_questions.describe = item.Describe;
        this.form_questions.name = item.Name;
        this.form_questions.radio_type = "问答题";
        this.form_questions.subject = item.Subject;
      }
      this.dialog_add_test_questions = true;
    },

    //进入试题
    question_management(item) {
      this.Submitted = item.Submitted;
      this.SheetType = item.SheetType;
      this.form_questions.radio_answer = ""; //清空单选答案
      this.form_questions.checkList = []; //清空多选答案
      this.form_questions.radio_judge = ""; //清空判断题答案
      this.form_questions.blanks = ""; //清空问答题答案
      this.blanks_type = false;

      this.question_active = item;
      let value = item.Questions;
      let arr = {
        SingleChoiceQuestion: [],
        MultiChoiceQuestion: [],
        TrueFalseQuestion: [],
        AnswerQuestion: [],
        ScratchQuestion: [],
      };
      value.forEach((v, i) => {
        get_answer_api(v.Id).then((r) => {
          v.Submitted = r.data.Submitted;
          this.$forceUpdate(); // 强制重新渲染页面
        });

        if (v.Type == "SingleChoiceQuestion") {
          arr.SingleChoiceQuestion.push(v);
          arr.SingleChoiceQuestion.forEach((res, indexs) => {
            res.Index = indexs;
          });
        } else if (v.Type == "MultiChoiceQuestion") {
          arr.MultiChoiceQuestion.push(v);
          arr.MultiChoiceQuestion.forEach((res, indexs) => {
            res.Index = indexs;
          });
        } else if (v.Type == "TrueFalseQuestion") {
          arr.TrueFalseQuestion.push(v);
          arr.TrueFalseQuestion.forEach((res, indexs) => {
            res.Index = indexs;
          });
        } else if (v.Type == "AnswerQuestion") {
          arr.AnswerQuestion.push(v);
          arr.AnswerQuestion.forEach((res, indexs) => {
            res.Index = indexs;
          });
        } else if (v.Type == "ScratchQuestion") {
          arr.ScratchQuestion.push(v);
          arr.ScratchQuestion.forEach((res, indexs) => {
            res.Index = indexs;
            console.log(res.ExtraField.ScratchField.Material);
            res.Material = res.ExtraField.ScratchField.Material;
          });
        }

        //当遍历到最后一次时
        if (i == value.length - 1) {
          this.question_tableData = arr;
          this.dialog_question_management = true;

          if (arr.SingleChoiceQuestion.length) {
            this.subject_active = arr.SingleChoiceQuestion[0];
            get_user_answer_api(
              this.subject_active.Id,
              this.userInfo.Name
            ).then((res) => {
              let value = res.data.Answer;
              if (this.subject_active.Submitted) {
                this.form_questions.radio_answer = value.SingleChoice;
              }
            });
            return false;
          } else if (arr.MultiChoiceQuestion.length) {
            this.subject_active = arr.MultiChoiceQuestion[0];
            get_user_answer_api(
              this.subject_active.Id,
              this.userInfo.Name
            ).then((res) => {
              let value = res.data.Answer;
              if (this.subject_active.Submitted) {
                this.form_questions.checkList = value.MultiChoice;
              }
            });
            return false;
          } else if (arr.TrueFalseQuestion.length) {
            this.subject_active = arr.TrueFalseQuestion[0];
            get_user_answer_api(
              this.subject_active.Id,
              this.userInfo.Name
            ).then((res) => {
              let value = res.data.Answer;
              if (this.subject_active.Submitted) {
                this.form_questions.radio_judge = value.TrueFalse;
              }
            });
            return false;
          } else if (arr.AnswerQuestion.length) {
            this.subject_active = arr.AnswerQuestion[0];
            get_user_answer_api(
              this.subject_active.Id,
              this.userInfo.Name
            ).then((res) => {
              let value = res.data.Answer;
              this.form_questions.blanks = value.Answer;
              this.blanks_type = true;
            });
            return false;
          } else if (arr.ScratchQuestion.length) {
            this.subject_active = arr.ScratchQuestion[0];
            get_user_answer_api(
              this.subject_active.Id,
              this.userInfo.Name
            ).then((res) => {
              this.blanks_type = true;
            });
            return false;
          }
        }
      });
    },

    //做题弹框确定
    determine_test_questions() {
      if (this.form_questions.radio_type == "单选题") {
        if (typeof this.form_questions.radio_answer == "string") {
          this.$message.error("答案不能为空！");
          return false;
        }
        let data = {
          singleChoice: this.form_questions.radio_answer,
        };

        put_answer_api(this.form_questions.id, data).then(() => {
          this.$message.success("提交成功！");
          this.dialog_add_test_questions = false;
        });
      } else if (this.form_questions.radio_type == "多选题") {
        if (this.form_questions.checkList.length == 0) {
          this.$message.error("答案不能为空！");
          return false;
        }
        let data = {
          multiChoice: this.form_questions.checkList,
        };

        put_answer_api(this.form_questions.id, data).then(() => {
          this.$message.success("提交成功！");
          this.dialog_add_test_questions = false;
        });
      } else if (this.form_questions.radio_type == "判断题") {
        let data = {
          trueFalse: this.form_questions.radio_judge,
        };

        put_answer_api(this.form_questions.id, data).then(() => {
          this.$message.success("提交成功！");
          this.dialog_add_test_questions = false;
        });
      } else if (this.form_questions.radio_type == "问答题") {
        if (!this.form_questions.blanks) {
          this.$message.error("答案不能为空！");
          return false;
        }

        let data = {
          answer: this.form_questions.blanks,
        };

        put_answer_api(this.form_questions.id, data).then(() => {
          this.$message.success("提交成功！");
          this.dialog_add_test_questions = false;
        });
      }
    },

    //监听添加试题弹框关闭事件
    dialog_close() {
      this.form_questions_type = false;
    },

    //提交题库
    submit_question_bank() {
      put_submission_api(this.question_active.Id).then(() => {
        this.$message.success("提交成功！");
        this.dialog_question_management = false;
      });
    },

    //提交试题
    submit_test_paper() {
      if (this.Submitted && this.SheetType == "Template") {
        this.$message.error("试题已提交！");
        return false;
      }

      let data = {},
        value = [],
        index = this.subject_active.Index;
      if (this.subject_active.Type == "SingleChoiceQuestion") {
        if (typeof this.form_questions.radio_answer == "string") {
          this.$message.error("答案不能为空！");
          return false;
        }
        data = {
          singleChoice: this.form_questions.radio_answer,
        };
        value = this.question_tableData.SingleChoiceQuestion;
      } else if (this.subject_active.Type == "MultiChoiceQuestion") {
        if (this.form_questions.checkList.length == 0) {
          this.$message.error("答案不能为空！");
          return false;
        }
        data = {
          multiChoice: this.form_questions.checkList,
        };
        value = this.question_tableData.MultiChoiceQuestion;
      } else if (this.subject_active.Type == "TrueFalseQuestion") {
        if (typeof this.form_questions.radio_judge == "string") {
          this.$message.error("答案不能为空！");
          return false;
        }
        data = {
          trueFalse: this.form_questions.radio_judge,
        };
        value = this.question_tableData.TrueFalseQuestion;
      } else if (this.subject_active.Type == "AnswerQuestion") {
        if (!this.form_questions.blanks) {
          this.$message.error("答案不能为空！");
          return false;
        }
        data = {
          answer: this.form_questions.blanks,
        };
        value = this.question_tableData.AnswerQuestion;
      }

      put_answer_api(this.subject_active.Id, data).then(() => {
        value[index].Submitted = true;
        this.$forceUpdate();
        this.$message.success("提交成功！");
        this.dialog_add_test_questions = false;
      });
    },

    //点击题目事件
    radio_click(item) {
      this.form_questions.radio_answer = ""; //清空单选答案
      this.form_questions.checkList = []; //清空多选答案
      this.form_questions.radio_judge = ""; //清空判断题答案
      this.form_questions.blanks = ""; //清空问答题答案
      this.blanks_type = false;

      this.subject_active = item;
      get_user_answer_api(item.Id, this.userInfo.Name).then((res) => {
        let value = res.data.Answer;
        if (item.Type == "SingleChoiceQuestion" && item.Submitted) {
          this.form_questions.radio_answer = value.SingleChoice;
        } else if (item.Type == "MultiChoiceQuestion" && item.Submitted) {
          this.form_questions.checkList = value.MultiChoice;
        } else if (item.Type == "TrueFalseQuestion" && item.Submitted) {
          this.form_questions.radio_judge = value.TrueFalse;
        } else if (item.Type == "AnswerQuestion") {
          this.form_questions.blanks = value.Answer;
          this.blanks_type = true;
        }
      });
    },

    //下一题
    next_topic() {
      if (this.subject_active.Type == "SingleChoiceQuestion") {
        let value = this.question_tableData.SingleChoiceQuestion;
        if (this.subject_active.Index + 1 < value.length) {
          this.subject_active = value[this.subject_active.Index + 1];
        } else {
          if (this.question_tableData.MultiChoiceQuestion.length) {
            this.subject_active = this.question_tableData.MultiChoiceQuestion[0];
          } else if (this.question_tableData.TrueFalseQuestion.length) {
            this.subject_active = this.question_tableData.TrueFalseQuestion[0];
          } else if (this.question_tableData.AnswerQuestion.length) {
            this.subject_active = this.question_tableData.AnswerQuestion[0];
          } else {
            this.$message.error("此题为最后一题！");
          }
        }
      } else if (this.subject_active.Type == "MultiChoiceQuestion") {
        let value = this.question_tableData.MultiChoiceQuestion;
        if (this.subject_active.Index + 1 < value.length) {
          this.subject_active = value[this.subject_active.Index + 1];
        } else {
          if (this.question_tableData.TrueFalseQuestion.length) {
            this.subject_active = this.question_tableData.TrueFalseQuestion[0];
          } else if (this.question_tableData.AnswerQuestion.length) {
            this.subject_active = this.question_tableData.AnswerQuestion[0];
          } else {
            this.$message.error("此题为最后一题！");
          }
        }
      } else if (this.subject_active.Type == "TrueFalseQuestion") {
        let value = this.question_tableData.TrueFalseQuestion;
        if (this.subject_active.Index + 1 < value.length) {
          this.subject_active = value[this.subject_active.Index + 1];
        } else {
          if (this.question_tableData.AnswerQuestion.length) {
            this.subject_active = this.question_tableData.AnswerQuestion[0];
          } else {
            this.$message.error("此题为最后一题！");
          }
        }
      } else if (this.subject_active.Type == "AnswerQuestion") {
        let value = this.question_tableData.AnswerQuestion;
        if (this.subject_active.Index + 1 < value.length) {
          this.subject_active = value[this.subject_active.Index + 1];
        } else {
          this.$message.error("此题为最后一题！");
        }
      }
    },

    //单选事件
    radio_change() {
      this.submit_test_paper();
    },

    //多选事件
    checkbox_change() {
      this.submit_test_paper();
    },

    //进入sc编辑器
    to_scratch() {
      if (this.subject_active.Submitted) {
        get_user_answer_api(this.subject_active.Id, this.userInfo.Name).then(
          (res) => {
            var url =
              "/scratch/?id=" + res.data.Answer.Scratch + "&stageArea=false";
            window.open(url);
          }
        );
      } else {
        var url =
          "/scratch/?Material=" +
          this.subject_active.Material +
          "&subjectId=" +
          this.subject_active.Id +
          "&stageArea=false";
        window.open(url);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.el-card {
  margin:16px;
  .title {
      color:#333;
      font-size:20px;
  }
  .el-table {
    margin-top:30px;
  }

  .questions {
    background:#f8f8f8;
    border:1px solid #f3f3f3;
    padding:16px;
    border-radius:6px;
    margin-bottom:30px;
    p {
      margin-bottom:14px;
      span {
        color:#F56C6C;
        margin-right:4px;
      }
    }
  }
}

>>>.el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}

>>>.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}

>>>.el-date-editor.el-input {
  width: auto;
}

>>>.el-dialog__footer {
  margin-top:0px;
}

>>>.el-radio__label {
  padding-left: 0;
}

.vhtml_img >>> img {
   width: 100px;
}

.dialog_questions_style {
  display: flex;
  justify-content:space-between;
  .left {
    font-size: 18px;
    font-weight:bold
  }
}

.dialog_questions_style_bottom {
  padding:12px;
  background:#eee;
  margin-top:20px;
  .title {
    color:#333;
    font-size:16px;
  }

  .content {
    font-size:14px;
    color:#000;
    margin-top:12px;
  }

  .radio_style {
    margin-top:26px;
    .radio_style_bottom {
      margin-top:12px;
    }
    ul {
      width:100%;
      display:flex;
      li {
        width:14%;
        height:200px;
        background:#ccc;
        margin-right:20px;
        overflow:hidden;
        position:relative
        .el-button {
          position:absolute;
          bottom:8%;
          left:50%;
          transform:translateX(-50%);
        }
        img {
          height:100%;
        }
      }
    }
  }
}

.answer_sheet {
  background: #eee;
  padding:12px;
  margin-top:20px;
  .title {
    color:#333;
    font-size:16px;
  }

  .choice_questions {
    .title {
      margin-top:30px;
      font-size:14px;
      color:#333;
    }

    .radio {
      width:30px;
      height:30px;
      border-radius: 16px;
      background: #fff;
      margin-top:14px;
      text-align: center;
      line-height: 30px;
      font-size: 14px;
      cursor: pointer;
      border:1px solid #fff;
      // color:#333 !important;
    }

      .radio_active {
         width:30px;
         height:30px;
         border-radius: 16px;
         background: #fff;
         margin-top:14px;
         text-align: center;
         line-height: 30px;
         font-size: 14px;
         cursor: pointer;
         border:1px solid #409EFF !important;
         color:#409EFF !important;
      }

    .radio:hover {
      transition:all 0.5s;
      border:1px solid #409EFF;
    }

    .radio_display {
      display: flex;
      .radio {
        margin-right: 14px;
      }
      .radio_active{
        margin-right: 14px;
        }
    }
  }
}
</style>
